// @flow
import { schema } from 'normalizr';

import { routeStop } from './routeStops';


export const route = new schema.Entity('routes', {
  // stops: [routeStop],
  start_stop: routeStop,
  end_stop: routeStop,
});
export const arrayOfRoutes = new schema.Array(route);

export const routeDescription = new schema.Entity('routeDescriptions', {
  start_stop: routeStop,
  end_stop: routeStop,
  pick_or_drop_stop: routeStop,
});
export const arrayOfRouteDescriptions = new schema.Array(routeDescription);



// WEBPACK FOOTER //
// ./src/scripts/api/schemas/routes.js